module.exports = "/_next/static/images/virtual-card-red-f7facc6fedb005e913e564b60b2dc533.svg";